// Based on: https://www.npmjs.com/package/react-list-editable

import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Button, List, ListItem, MenuItem, Select, Typography } from '@mui/material';
import { Box, styled } from '@mui/system';
import { useEffect } from 'react';
import { useState } from 'react';

const LocalStyledList = styled(List)(({theme}) => ({ // maybe share this with EditableAdminRoles.
    border: '1px solid #e1e3e5',
    display: 'inline-block',
    paddingRight: '0',
    ':hover': {
        background: '#f1f3f5',
        // cursor: 'text',
    }
}));

export function EditableList({list, selectFrom, placeholder, onListChange}) {

    console.log(`EditableList()`, {list, selectFrom, placeholder, onListChange})

    const [theList, setTheList] = useState(list || [])

    useEffect(() => {
        if (onListChange && typeof(onListChange) === 'function') {
            onListChange(theList)
        }
    // (linter is worried about onListChange but it's an output function)
    // eslint-disable-next-line 
    }, [theList])

    const deleteItem = (index) => {
        const newList = [...theList]; // copy array
        newList.splice(index, 1);
        setTheList(newList)
    };

    const handleDeleteButtonClick = (event, index) => {
        console.log('handleDeleteButtonClick')
        event.preventDefault();
        deleteItem(index);
    };

    const handleSelectChange = (event) => {
        console.log(' handleSelectChange', event)
        const newList = [...theList]; // copy array
        setTheList(newList.concat(event.target.value))
    };

    const handleRenderSelect = (selected) => {
        let result = placeholder ? <em>{placeholder}</em> : <em>Add an item</em>
        if (false && selected.length > 0) {
            result = selected.join(', ')
        }
        return result
    }

    const notYetSelect = selectFrom.filter((option) => { return !theList.includes(option)})

    return (
        <Box>
            <LocalStyledList>
                {
                    theList.map((thisListItem, index) => {
                        return (
                            <ListItem dense={true} sx={{px: 1}} key={thisListItem}>
                                <Typography variant="body2" sx={{minWidth: '12em'}}>{thisListItem}</Typography>
                                <Button size="small" sx={{p: 0}} onClick={(e) => {handleDeleteButtonClick(e, index)}}>
                                    <DeleteForeverIcon fontSize="small" />
                                </Button>
                            </ListItem>
                        )
                    })
                }
                {
                    notYetSelect.length > 0
                    &&
                    <ListItem dense={true} sx={{px: 1}} key="add-a-role">
                        <Select value="" label="Add a role" onChange={handleSelectChange} displayEmpty renderValue={handleRenderSelect}>
                        {
                            notYetSelect.map((thisOption) => {
                                return <MenuItem value={thisOption} key={thisOption}>{thisOption}</MenuItem>
                            })
                        }
                        </Select>
                    </ListItem>
                }
            </LocalStyledList>
        </Box>
    )
}
